export default __webpack_public_path__ + "static/media/helper-description.4817195e.png";